import React, { Component } from 'react'
import { ReactComponent as AttentionIcon} from '../../resources/imgs/attention-icon.svg';

export class DeleteAttention extends Component {

    renderBody = () => {

        return <div className={"attention-body"}>
            <AttentionIcon/>
            <div className={"onelight-attention-text"} style={{marginTop: "12px"}}>
                Are you sure ?
            </div>
            <div className={"onelight-attention-description-text"} style={{marginTop: "25px"}}>
                Your will not be able to recover this <b>{this.props.description}</b>
            </div>
        </div>
    }

    renderFooter = () => {

        return <div className={"attention-footer"}>
            <button className={"onelight-second-btn"} onClick={()=>{this.props.cancel()}}>
                Cancel
            </button>

            <button className={"onelight-delete-btn"} style={{
                marginLeft: "25px",
            }}
                    onClick={() => {
                        this.props.onDelete()
                    }}
            >
                Yes, delete it!
            </button>
        </div>
    }

    render () {
        return (
            <div className={"attention-container"}>
                {this.renderBody()}
                {this.renderFooter()}
            </div>
        )
    }
}